import { getApiUrl } from './Utils';

export const API_URL = getApiUrl();

export const APP_ROOT = 'root';